export default __webpack_public_path__ + "static/media/rudlingTech1Low.48a98c1e.jpg";